import { Text } from '@dixa/lib-shared-habla';

/** Details for claimed authentication. */
export function ClaimedDetails(): JSX.Element {
  return (
    <Text.Paragraph>
      Name and email are requested before starting a conversation. An icon is
      displayed in the agent interface to indicate that the user has identified
      themselves.
    </Text.Paragraph>
  );
}
